import { Check1Bold } from '@ha/icons';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useIntl } from 'ha/i18n';

const useStyles = makeStyles()(theme => ({
  checkIcon: {
    marginRight: theme.spacing(1),
  },
}));

export const IncludedCheckmark: React.FC = React.memo(() => {
  const { classes } = useStyles();
  const { T } = useIntl();
  return (
    <React.Fragment>
      <Check1Bold
        fontSize="small"
        color="secondary"
        className={classes.checkIcon}
      />
      {T('Included')}
    </React.Fragment>
  );
});
